import React, { useState, useRef, useEffect } from 'react';
import LocationCard from './LocationCard';
import CarouselControls from './CarouselControls';

const LocationsCarousel = ({ locations, onViewDetails }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [cardsToShow, setCardsToShow] = useState(4);
  
  const [touchStart, setTouchStart] = useState(0);
  const [touchEnd, setTouchEnd] = useState(0);

  useEffect(() => {
    const updateCardsToShow = () => {
      const width = window.innerWidth;
      if (width < 768) setCardsToShow(1);
      else if (width < 900) setCardsToShow(2);
      else if (width < 1200) setCardsToShow(3);
      else setCardsToShow(4);
    };
    updateCardsToShow();
    window.addEventListener('resize', updateCardsToShow);
    return () => window.removeEventListener('resize', updateCardsToShow);
  }, []);

  // Resetujemo index ako filter smanji broj lokacija ispod trenutnog indexa
  useEffect(() => {
    if (currentIndex > locations.length - cardsToShow) {
      setCurrentIndex(Math.max(0, locations.length - cardsToShow));
    }
  }, [locations.length, cardsToShow, currentIndex]);

  const maxIndex = locations.length - 1;
  const nextSlide = () => setCurrentIndex(prev => Math.min(prev + 1, Math.max(0, locations.length - cardsToShow)));
  const prevSlide = () => setCurrentIndex(prev => Math.max(prev - 1, 0));

  const handleTouchStart = (e) => setTouchStart(e.targetTouches[0].clientX);
  const handleTouchMove = (e) => setTouchEnd(e.targetTouches[0].clientX);
  const handleTouchEnd = () => {
    if (!touchStart || !touchEnd) return;
    const distance = touchStart - touchEnd;
    if (distance > 50) nextSlide();
    if (distance < -50) prevSlide();
    setTouchStart(0);
    setTouchEnd(0);
  };

  const getTransform = () => {
    // Procentualni pomak: index pomnožen sa (100 podeljeno sa brojem kartica)
    const step = 100 / cardsToShow;
    const maxScroll = Math.max(0, locations.length - cardsToShow);
    const scrollIndex = Math.min(currentIndex, maxScroll);
    return `translateX(-${scrollIndex * step}%)`;
  };

  return (
    <div className="locations-carousel">
      <div className="locations-carousel-container">
        <div 
          className="locations-carousel-slider"
          onTouchStart={handleTouchStart}
          onTouchMove={handleTouchMove}
          onTouchEnd={handleTouchEnd}
        >
          <div 
            className="locations-carousel-track" 
            style={{ 
              transform: getTransform(),
              // Prosleđujemo cardsToShow kao CSS varijablu za lakši calc u CSS-u
              "--cards-per-view": cardsToShow 
            }}
          >
            {locations.map((location, index) => (
              <div key={location.id} className="location-carousel-item">
                <LocationCard location={location} index={index} onViewDetails={onViewDetails} />
              </div>
            ))}
          </div>
        </div>

        <CarouselControls 
          onNext={nextSlide} 
          onPrev={prevSlide} 
          currentIndex={currentIndex} 
          setCurrentIndex={setCurrentIndex} 
          totalItems={locations.length}
        />
      </div>
    </div>
  );
};

export default LocationsCarousel;